import { render, staticRenderFns } from "./time_yellow_s.vue?vue&type=template&id=3cb33adc&scoped=true"
import script from "./time_yellow_s.vue?vue&type=script&lang=js"
export * from "./time_yellow_s.vue?vue&type=script&lang=js"
import style0 from "./time_yellow_s.vue?vue&type=style&index=0&id=3cb33adc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb33adc",
  null
  
)

export default component.exports